export default __webpack_public_path__ + "static/media/G0003.a46538b2.png";